// extracted by mini-css-extract-plugin
module.exports = {"mail":"Mail_mail__1oXTs","mailLabelAndText":"Mail_mailLabelAndText__3_6Vx","mailLabel":"Mail_mailLabel__4oDwN","mailText":"Mail_mailText__v3vHt"};